import React from "react";
import InvoiceForm from "./InvoiceForm";

export default function CreateInvoice() {
  return (
    <div className="mt-5">
      <InvoiceForm />
    </div>
  );
}
